import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../utils/api';
import '../styles/auth.css';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiClient.forgotPassword(email);
      const token = res.data.data?.token;
      setResetToken(token ?? '');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (resetToken) {
    const resetUrl = `${window.location.origin}/reset-password?token=${resetToken}`;
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Logistics Platform</h1>
          <h2>Check Your Email</h2>
          <div style={{ background: '#dcfce7', color: '#166534', padding: '12px 14px', borderRadius: 6, marginBottom: 20, fontSize: 14 }}>
            A password reset link has been generated.
          </div>
          {/* Dev/demo: show the link directly since there's no email service */}
          <div style={{ background: '#f1f5f9', borderRadius: 6, padding: 12, marginBottom: 20 }}>
            <p style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>Reset link (use this to reset your password):</p>
            <a href={resetUrl} style={{ fontSize: 12, color: '#3b82f6', wordBreak: 'break-all' }}>{resetUrl}</a>
          </div>
          <div className="auth-footer">
            <Link to="/login">← Back to Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Logistics Platform</h1>
        <h2>Forgot Password</h2>
        <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20, textAlign: 'center' }}>
          Enter your email and we'll send you a reset link.
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email" id="email" value={email}
              onChange={e => setEmail(e.target.value)}
              required placeholder="your@email.com"
            />
          </div>
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/login">← Back to Login</Link>
        </div>
      </div>
    </div>
  );
};
